import styled from 'styled-components'

export const Radio = styled.div<{ isSelected: boolean }>`
  position: relative;
  width: ${({ isSelected }) => (isSelected ? '100%' : '0')};
  opacity: ${({ isSelected }) => (isSelected ? 1 : 0)};

  -webkit-transition: all 0.2s;
  transition: all 0.2s;

  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  label {
    position: relative;
    height: 40px;
    width: ${({ isSelected }) => (isSelected ? '100%' : '0')};
    visibility: ${({ isSelected }) => (isSelected ? 'visible' : 'hidden')};
    padding: 12px 24px;
    display: block;

    border: 1px solid ${props => props.theme.colors.colordfe3e8};
    border-radius: ${({ theme }) => theme.zds.border.radius100};
    cursor: pointer;

    font-family: 'Inter';
    color: ${props => props.theme.colors.color545e6c};
    font-weight: 400;
    font-size: ${({ isSelected }) => (isSelected ? '14px' : '0')};
    text-align: center;
    font-size: 14px;

    -webkit-transition: all 0.2s;
    transition: all 0.2s;

    &:hover {
      color: ${({ theme }) => theme.zds.colors.neutral1000};
      font-weight: 700;
      background-color: ${props => props.theme.colors.color378ff7};
    }
  }

  input:checked ~ label {
    color: ${({ theme }) => theme.zds.colors.neutral1000};
    font-weight: 700;
    background-color: ${props => props.theme.colors.color378ff7};
  }
`
